// extracted by mini-css-extract-plugin
export default {"editTableButton":"Schedule_editTableButton__HBFTx","patientForm":"Schedule_patientForm__Ze6Dq","chosenRow":"Schedule_chosenRow__HnzgC","errorMessage":"Schedule_errorMessage__hriZR"};